/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { AvailabilityInfoFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { AvailabilityInfoFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const availabilityInfoDataMock: AvailabilityInfoFragmentFragment = {
  availability: {
    message: 'lieferbar in 2-3 Wochen',
    state: 'AVAILABLE',
  },
  delivery: {
    deliverySize: 'DEFAULT',
  },
};

export function getAvailabilityInfoFragmentedData(data?: AvailabilityInfoFragmentFragment) {
  return makeFragmentData(data || availabilityInfoDataMock, AvailabilityInfoFragmentFragmentDoc);
}
